// extracted by mini-css-extract-plugin
export default {"footer":"MobileFooter_footer__zlpvK","logoBox":"MobileFooter_logoBox__vLVMM","linkBox":"MobileFooter_linkBox__-JjOV"};